enum QuestionType {
    Choice = 'Choice',
    Exact = 'Exact',
    Likert = 'Likert',
}

export default QuestionType;
